export default "/CityBus_Stand.glb";